module.exports = __webpack_public_path__ + "static/media/plus-thin-copy.2e3c08cb.svg";